import { Component, OnInit } from '@angular/core';
import { ApartmentTypesBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-houses',
  templateUrl: './houses.component.html',
  styleUrls: ['./houses.component.scss']
})

export class HousesComponent extends ApartmentTypesBaseComponent implements OnInit {
  pageType: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.pageType = this.route.snapshot.data.page_type;

    switch (this.pageType) {
      case 'apartamente-noi-rahova-salaj-sector5-bucuresti':
        this.setTitle('Apartamente noi sector 5 de la dezvoltator');
        this.setMetaDescription(`
          Apartamente si garsoniere noi de vanzare in sectorul 5.
          Vezi promotiile de pret pentru garsoniere si apartamente noi in sectorul 5.
        `);
        break;
      case 'cartierul-nou-salaj':
        this.setTitle('Cartierul Nou Salaj - Apartamente 2, 3 camere, Garsoniere');
        this.setMetaDescription(`
          Cartierul Nou Salaj - poti alege apartamente de 2 camere, de 3 camere si
          garsoniere de vanzare in cadrul complexului rezidential Dream Residence.
        `);
        break;
      case 'garsoniere-de-vanzare-rahova-sector-5':
        this.setTitle('Garsoniere de vanzare - Dream Residence, sector 5, Rahova');
        this.setMetaDescription(`
          Garsoniere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).
          Dream Residence e mai mult decat un cartier, e o comunitate!
        `);
        break;
      case 'apartamente-2-camere-de-vanzare-rahova-sector-5':
        this.setTitle('Apartamente 2 camere de vanzare: Dream Residence, sector 5, Rahova');
        this.setMetaDescription(`
          Apartamente 2 camere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).
          Dream Residence e mai mult decat un cartier, e o comunitate!
        `);
        break;
      case 'apartamente-3-camere-de-vanzare-rahova-sector-5':
        this.setTitle('Apartamente 3 camere de vanzare: Dream Residence, sector 5, Rahova');
        this.setMetaDescription(`
          Apartamente 3 camere de vanzare - Dream Residence, Rahova (sector 5, zona Sebastian, Pucheni).
          Dream Residence e mai mult decat un cartier, e o comunitate!
        `);
        break;
      default:
        this.setTitle('Apartamente 2, 3 camere, garsoniere de vanzare in sector 5');
        this.setMetaDescription(`
          Vezi apartamente de 2 camere, de 3 camere si garsoniere de vanzare in cadrul complexului rezidential Dream Residence.
          Toate detaliile pe site.
        `);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts